import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { EventsState } from '../../../store/types';
import { BLAdmin } from '../../../types/working-model';
import Modal from '../../general-ui/modal/modal';
import './access-icons.scss';
import ChannelAdmins from '../settings/channel-admins';
import { useCallback } from 'react';

interface Props {
	addAccess: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function AccessIcons(props: Props): JSX.Element {

	const {
		ChannelAdminReducer: { admins },
	} = useSelector((state: EventsState) => state);

	const [accessModalOpen, setAccessModalOpen] = useState(false);

	const headerIcons = useMemo(() => {
		return admins.map((admin: BLAdmin) => {
			if (admin.profile.picture) { return admin.profile.picture; }
		});
	}, [admins]);

	const minifiedIcons = useMemo(() => {
		const array = [];
		for (let i = 0; i < headerIcons.length; i++) {
			if (array.length < 3 && headerIcons[i]) { array.push(headerIcons[i]); }
		}
		return array;
	}, [headerIcons]);

	const closeAccessModal = useCallback(() => {
		setAccessModalOpen(false);
	}, []);

	return (
		<div className="access-icons-container">
			<button className="no-style" onClick={() => setAccessModalOpen(true)}>
				{minifiedIcons ? (
					minifiedIcons.map((icon: any) => {
						return (
							<div key={icon} className="access-icon">
								<img src={icon} />
							</div>
						);
					})
				) : (
					<></>
				)}
				{headerIcons.length > 3 ? (
					<div className="access-icon">+{headerIcons.length - 3}</div>
				) : (
					<></>
				)}
			</button>
			<Modal
				open={accessModalOpen}
				title={'Channel Access'}
				onRequestClose={closeAccessModal}
				cancellable={true}
				closeable={true}
			>
				<ChannelAdmins />
			</Modal>
		</div>
	);
}
